import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import blogsData from "./BlogData";

const Features = () => {
     useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
  return (
   <div >
    

     {/* Breadcrumb */} 
<section
  className="section mt-5 contact-hero"
  style={{
    backgroundImage: `url('/assets/img/about-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '60px 0',
    position: 'relative',
    color: '#fff',
    textAlign: 'center',
  }}
>
  {/* Overlay for fade effect */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)', // fade effect
      zIndex: 1,
    }}
  ></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <nav className="custom-breadcrumbs mb-3">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <a href="/feature">features</a>
        </nav>
        <h1 style={{color:'#c5c5c5'}} className="display-4 fw-bold">Our Features</h1>
        <p className="lead mt-3">
          Reach out to us for web development services, inquiries, or support.
        </p>
      </div>
    </div>
  </div>
</section>
  
  
    {/* Features  Section */}
    <section id="features" className="features-2 section mt-5">
  <div className="container" data-aos="fade-up" data-aos-delay={100}>
     <div
          className="section-title"
          data-aos="fade-up"
          style={{ marginBottom: "5px" }}
        >
          <h2>Our Values</h2>
          <p>
            We leverage the latest and most powerful technologies to build
            scalable, secure, and high-performing solutions across platforms.
          </p>
        </div>
    <div className="row align-items-center">


    <div className="container py-5">
  <div className="row g-4">

    {/* Card 1 */}
<div className="col-lg-4 col-md-6">
  <div className="feature-card" data-aos="fade-up" data-aos-delay="100">
    <i className="bi bi-people feature-icon"></i>
    <h3>Customer Focus</h3>
    <p>
      We place our clients at the core of every decision and interaction. 
      By understanding their evolving requirements and future goals, we deliver 
      tailored strategies and personalized solutions. Our vision is to build 
      long-term partnerships based on trust, strong communication, and measurable value.
    </p>
    <div className="animation-dot"></div>
  </div>
</div>

{/* Card 2 */}
<div className="col-lg-4 col-md-6">
  <div className="feature-card" data-aos="fade-up" data-aos-delay="200">
    <i className="bi bi-shield-check feature-icon"></i>
    <h3>Integrity</h3>
    <p>
      We are committed to operating with honesty, responsibility, and transparency. 
      Every action and decision is guided by ethical practices while maintaining 
      confidentiality and respect. Integrity isn’t just a value — it’s the foundation 
      of every relationship we build with clients and teams.
    </p>
    <div className="animation-dot"></div>
  </div>
</div>

{/* Card 3 */}
<div className="col-lg-4 col-md-6">
  <div className="feature-card" data-aos="fade-up" data-aos-delay="300">
    <i className="bi bi-trophy feature-icon"></i>
    <h3>Excellence</h3>
    <p>
      We believe excellence is a continuous journey. Our team consistently strives 
      to exceed expectations by delivering innovative and high-quality solutions. 
      Through performance-driven strategies and advanced methodologies, we ensure 
      every project adds meaningful impact and measurable outcomes.
    </p>
    <div className="animation-dot"></div>
  </div>
</div>

{/* Card 4 */}
<div className="col-lg-4 col-md-6">
  <div className="feature-card" data-aos="fade-up" data-aos-delay="400">
    <i className="bi bi-people-fill feature-icon"></i>
    <h3>Collaboration</h3>
    <p>
      We believe the greatest results are achieved through teamwork. 
      With open communication, shared ideas, and a unified vision, 
      we build strong internal and external collaborations. Together, 
      we create innovative solutions that bring success and long-term value.
    </p>
    <div className="animation-dot"></div>
  </div>
</div>

{/* Card 5 */}
<div className="col-lg-4 col-md-6">
  <div className="feature-card" data-aos="fade-up" data-aos-delay="500">
    <i className="bi bi-book feature-icon"></i>
    <h3>Continuous Learning</h3>
    <p>
      We embrace curiosity and growth. By constantly upgrading our skills, 
      adopting modern technologies, and learning from industry trends, 
      we remain future-ready. This culture of continuous learning empowers 
      us to deliver innovative, scalable, and cutting-edge solutions.
    </p>
    <div className="animation-dot"></div>
  </div>
</div>

{/* Card 6 */}
<div className="col-lg-4 col-md-6">
  <div className="feature-card" data-aos="fade-up" data-aos-delay="600">
    <i className="bi bi-globe feature-icon"></i>
    <h3>Social Responsibility</h3>
    <p>
      We are dedicated to making a meaningful difference beyond business. 
      By promoting sustainability, diversity, ethical work culture, and community 
      upliftment, we aim to create a balanced and positive impact on society 
      and the environment — now and for future generations.
    </p>
    <div className="animation-dot"></div>
  </div>
</div>


  </div>
</div>


    </div>
  </div>
</section>

    {/* /Features Section */}
  
    
  
 
</div>

  )
}

export default Features;

